// How this document was loaded: 'navigate', 'reload' or 'back_forward'.
export function documentNavigationType() {
  try {
    return performance.getEntriesByType('navigation')[0]?.type ?? 'navigate';
  } catch {
    return 'navigate';
  }
}
